import { navigateToHeydayPage, subscribeToHeydayLocation } from '../../config/heydayRoutes';
import type {
  IntegrationSettingsRoute,
  IntegrationSettingsRoutePort,
} from '../../features/integrations/public';

function readIntegrationSettingsRoute(): IntegrationSettingsRoute {
  const parameters = new URLSearchParams(window.location.search);
  const view = parameters.get('view');
  if (view === 'directory' || view === 'messaging') return view;
  const provider = parameters.get('provider');
  return provider === 'google-workspace' || provider === 'slack' || provider === 'absence-sync'
    ? provider
    : 'overview';
}

export const integrationSettingsRouteAdapter: IntegrationSettingsRoutePort = {
  read: readIntegrationSettingsRoute,
  navigate(route) {
    const query = route === 'overview' ? undefined
      : route === 'directory' || route === 'messaging' ? `view=${route}` : `provider=${route}`;
    navigateToHeydayPage('admin-integrations', query);
  },
  subscribe: subscribeToHeydayLocation,
};
